import { PetitionEmbed } from "../../../../src/components/ctas/petition-embed.js";
import { AllSupervisorWithLocationEmailCTA } from "../../../../src/components/ctas/supervisor_email";
import * as React from 'react';
export default {
  PetitionEmbed,
  AllSupervisorWithLocationEmailCTA,
  React
};